import type { SharedBudget, SharedBudgetServer } from '@metapic-apps/shared'

import { type CampaignTypeEnum } from '@/lib/types/campaign.types'
import type {
  FilterType,
  MoneyServerType,
  MoneyType,
  ProcessableImageType,
  ProcessableServerImageType,
} from '@/lib/types/common.types'
import type {
  TrafficSourceCostServerType,
  TrafficSourceCostsType,
} from '@/lib/types/traffic-source-costs.types'

export enum CampaignStatusEnum {
  Ended = 'ended',
  Scheduled = 'scheduled',
  Paused = 'paused',
  Active = 'active',
}

export type CampaignListItemServerType = {
  id: number
  type: CampaignTypeEnum
  status: CampaignStatusEnum
  created_at: string
  updated_at: string
  constraints: {
    current_clicks?: number
    current_money?: number
    max_clicks?: number
    max_money?: number
    per_user_limit?: boolean
    valid_from?: string
    valid_until?: string
  }
  has_product_seeding: boolean
  image_url: string
  image?: ProcessableServerImageType
  name: string
  offer_campaign_title: string
  offer_campaign_test: string
  priority: number
  show_for_advertiser: boolean
  traffic_sources_costs?: TrafficSourceCostServerType[]
  store_id: number
  store_logo: ProcessableServerImageType
  store_name: string
  currency: string
  consumed_budget?: {
    amount: number
    currency: string
  }
  shared_budget?: SharedBudgetServer
  budget_limit_v2?: MoneyServerType
  targets?: {
    user_ids: number[]
    store_group_ids: number[]
    user_tag_ids: number[]
    client_ids: number[]
    revenue_tier_ids: number[]
    emails: string[]
    social_media_identifiers: string[]
  }
}

export type CampaignListItemType = {
  id: number
  type: CampaignTypeEnum
  status: CampaignStatusEnum
  internalName: string
  trafficSourceCosts?: TrafficSourceCostsType[]
  advertiserLogo?: ProcessableImageType
  advertiserId: number
  advertiserName: string
  advertiserCurrency: string
  linksCount?: number
  currentClicks?: number
  maxClicks?: number
  currentMoney?: number
  maxMoney?: number
  validFrom?: string
  validUntil?: string
  image?: ProcessableImageType
  perUserLimit: boolean
  budgetLimit?: MoneyType
  consumedBudget?: MoneyType
  sharedBudget?: SharedBudget
  targets?: {
    users: number[]
    storeGroups: number[]
    userTags: number[]
    clients: number[]
    revenueTiers: number[]
    emails: string[]
    socialMediaIdentifiers: string[]
  }
}

export type CampaignsFilterType = {
  statuses?: CampaignStatusEnum[]
  customSortBy?: string
  format?: 'xlsx' | 'csv'
  targetUserId?: number
  createdBefore?: string
} & FilterType

export type CampaignPerformanceType = {
  labels: string[]
}
